<template>
  <div>
    <slot name="prepend" />
    {{ formatDate(value, 'DD.MM.YYYY') }} |
    <span class="grey--text">{{ formatDate(value, 'HH:mm:ss') }}</span>
    <slot name="append" />
  </div>
</template>
<script>
import { formatDate } from '@/utils'
export default {
  name: 'DateTimeCell',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  methods: {
    formatDate
  }
}
</script>
